<template>
  <div>
    <h1 class="headText">{{ title }}</h1>
    <div>
      <div v-if="map == 'true'" class="row">
        <div class="col-sm-12">
          <iframe
            class="mapN"
            src="https://www.google.com/maps/d/u/1/embed?mid=1muksqrCoTmm06RYdlCwrpjI40NE"
            width="640"
            height="380"
          ></iframe>
        </div>
      </div>
    </div>
    <div v-if="map != 'true'">
      <div class="contentbanner">
        <div
          class="banner"
          :style="{ backgroundImage: `url('${imgBanner}')` }"
        ></div>
        <div class="titleBanner">{{ title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    map: {
      type: String,
      default: "false"
    }
  },
  data: () => {
    return {
      imgBanner: require('@/assets/banner.png')
    };
  }
};
</script>
<style lang="scss">
.banner {
  width: 100%;
  height: 150px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: $p-color;
  filter: brightness(70%);
  border-top: 4px #0e263f solid;
  border-bottom: 4px #0e263f solid;
}
.mapN {
  width: 100%;
  height: 350px;
}
.headText {
  padding: 30px 0px 30px 300px;
  font-size: 2em;
  font-weight: 200;
}
.titleBanner {
  display: none;
}
@media (max-width: 700px) {
  .mapN {
    padding-top: 48px;
  }
  .contentbanner {
    margin-top: 48px;
  }
  .headText {
    display: none;
  }
  .banner {
    height: 80px;
    filter: brightness(50%);
    display: block;
    position: absolute;
    box-sizing: border-box;
  }
  .titleBanner {
    padding: 10px 10px;
    text-align: center;
    font-size: 1.2em;
    text-transform: uppercase;
    font-weight: 600;
    color: white;
    z-index: 20;
    position: relative;
    height: 80px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Raleway";
  }
}
</style>
